import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Copy } from 'lucide-react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Order } from '../../types/order';
import { toast } from 'react-toastify';

interface ModalOrderVastProps {
    isOpen: boolean;
    toggle: () => void;
    order: Order;
}

const ModalOrderVast: React.FC<ModalOrderVastProps> = ({ isOpen, toggle, order }) => {
    const adManagerVastTagUrl = `${process.env.REACT_APP_FASTLANE_API_URL}/vast?c=${order?.campaignId}&o=${order.id}&ui=%%PATTERN:iu%%&url=%%REFERRER_URL_ESC%%&description_url=%%DESCRIPTION_URL_ESC%%&width=%%WIDTH%%&height=%%HEIGHT%%&correlator=%%TAG_PARAM:correlator%%&ct=%%CLICK_URL_ESC%%&pv=%%PREVIEW_MODE%%&output=vast_4`;
    return (
        <Dialog open={isOpen} onOpenChange={toggle}>
            <DialogContent className="max-w-4xl">
                <DialogHeader>
                    <DialogTitle>TAG VAST</DialogTitle>
                    <DialogDescription>
                        Insira a TAG VAST abaixo no creative do seu Ad Manager.
                    </DialogDescription>
                </DialogHeader>
                <div className="space-y-4">
                    <div className="flex gap-2">
                        <Input
                            type="text"
                            value={adManagerVastTagUrl}
                            readOnly
                            className="cursor-pointer"
                            onClick={() => {
                                navigator.clipboard.writeText(adManagerVastTagUrl);
                                toast.success('TAG VAST copiada para a área de transferência!');
                            }}
                        />
                        <Button
                            type="button"
                            variant="outline"
                            onClick={() => {
                                navigator.clipboard.writeText(adManagerVastTagUrl);
                                toast.success('TAG VAST copiada para a área de transferência!');
                            }}
                        >
                            <Copy className="h-4 w-4" />
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ModalOrderVast;